export default "__VITE_ASSET__D2WMB5Rd__"